
import * as React from 'react';
import autobind from 'autobind-decorator';
import Icon from '__common/components/Icon';
import { Checkbox, FormControlLabel } from '@mui/material';
import { selectLagBolts, unSelectLagBolts } from '../../utils/partsSelectionFunctions';
import { getLegacyBomControlProps } from 'bom/components/LegacyBomCheckboxIcon';

type Props = {
  dispatch: Function,
  lagBolts: [bomPart, bomPart],
  attachmentGroup: string,
  legacyCheckboxIcons?: boolean,
};

export default class LagBoltsPart extends React.Component<Props, {}> {
  @autobind
  toggleLagBolts(checked: boolean) {
    const { lagBolts } = this.props;
    if (checked) {
      selectLagBolts(lagBolts);
    } else {
      unSelectLagBolts(lagBolts);
    }
  }

  render() {
    const { lagBolts, legacyCheckboxIcons = false } = this.props;
    return (
      <div className="lagBolts attachment-types-selector">
              <div className="lagBolts">
        <div className="control-panel-sublabel">
            Lag bolts
        </div>
        </div>
        <div className="attachment-group-items">
          <FormControlLabel
            className="attachment-item"
            control={
              <Checkbox
                {...getLegacyBomControlProps(legacyCheckboxIcons)}
                id={`lagBolts_${lagBolts[0].number}`}
                name="lagBolts_checkboxes[]"
                value={lagBolts[0].number}
                checked={lagBolts[0].selected || false}
                onChange={(event) => this.toggleLagBolts(event.target.checked)}
                disabled={lagBolts[0].disabled}
              />
            }
            label="I require Lag Bolts"
          />
        </div>
      </div>
    );
  }
}
